export default __webpack_public_path__ + "media/images/cta_blocks/start_guest_list-fa8bb32c3a6728a3e6907d0ca2abb5d4.jpg";